export default {
  id: "manual-estudiante",
  type: "multi_module",
  titleKey: "programs.manual_estudiante.title",
  descriptionKey: "programs.manual_estudiante.desc",
  durationDays: 112, // 16 weeks
  // Redistribuido desde el bloque "Recursos" de /formacion/ (2026-08-11) — vivían como
  // descargas genéricas al fondo de la página; acá son el material de origen de este
  // programa, contextual a quien ya lo está viendo.
  resourcePdfs: [
    { titleKey: "resources_student_manual", href: "/pdfs/Manual-del-Estudiante.pdf" },
    { titleKey: "resources_teacher_manual", href: "/pdfs/Manual-del-Maestro.pdf" },
  ],
  modules: [
    {
      id: "semana-1",
      titleKey: "programs.manual_estudiante.semana1.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.manual_estudiante.semana1.les1.title",
          contentBlocks: [
            { type: "verse", reference: "Proverbios 3:5-6", referenceKey: "programs.manual_estudiante.semana1.les1.reference1", textKey: "programs.manual_estudiante.semana1.les1.verse1" },
            { type: "verse", reference: "Mateo 20:25-28", referenceKey: "programs.manual_estudiante.semana1.les1.reference2", textKey: "programs.manual_estudiante.semana1.les1.verse2" },
            { type: "verse", reference: "1 Timoteo 3:1-7", referenceKey: "programs.manual_estudiante.semana1.les1.reference3", textKey: "programs.manual_estudiante.semana1.les1.verse3" },
            { type: "text", textKey: "programs.manual_estudiante.semana1.les1.objectives" },
          ],
          questions: [
            { id: "sem1-q1", type: "reflection", promptKey: "programs.manual_estudiante.semana1.les1.q1" },
            { id: "sem1-q2", type: "reflection", promptKey: "programs.manual_estudiante.semana1.les1.q2" },
            { id: "sem1-q3", type: "reflection", promptKey: "programs.manual_estudiante.semana1.les1.q3" },
            { id: "sem1-q4", type: "application", promptKey: "programs.manual_estudiante.semana1.les1.q4" },
          ],
        },
      ],
    },
    {
      id: "semana-2",
      titleKey: "programs.manual_estudiante.semana2.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.manual_estudiante.semana2.les1.title",
          contentBlocks: [
            { type: "verse", reference: "Hechos 1:8", referenceKey: "programs.manual_estudiante.semana2.les1.reference1", textKey: "programs.manual_estudiante.semana2.les1.verse1" },
            { type: "verse", reference: "Gálatas 5:22-25", referenceKey: "programs.manual_estudiante.semana2.les1.reference2", textKey: "programs.manual_estudiante.semana2.les1.verse2" },
            { type: "verse", reference: "Romanos 8:14", referenceKey: "programs.manual_estudiante.semana2.les1.reference3", textKey: "programs.manual_estudiante.semana2.les1.verse3" },
            { type: "text", textKey: "programs.manual_estudiante.semana2.les1.objectives" },
          ],
          questions: [
            { id: "sem2-q1", type: "reflection", promptKey: "programs.manual_estudiante.semana2.les1.q1" },
            { id: "sem2-q2", type: "reflection", promptKey: "programs.manual_estudiante.semana2.les1.q2" },
            { id: "sem2-q3", type: "reflection", promptKey: "programs.manual_estudiante.semana2.les1.q3" },
            { id: "sem2-q4", type: "application", promptKey: "programs.manual_estudiante.semana2.les1.q4" },
          ],
        },
      ],
    },
    {
      id: "semana-3",
      titleKey: "programs.manual_estudiante.semana3.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.manual_estudiante.semana3.les1.title",
          contentBlocks: [
            { type: "verse", reference: "Juan 13:12-17", referenceKey: "programs.manual_estudiante.semana3.les1.reference1", textKey: "programs.manual_estudiante.semana3.les1.verse1" },
            { type: "verse", reference: "Marcos 10:42-45", referenceKey: "programs.manual_estudiante.semana3.les1.reference2", textKey: "programs.manual_estudiante.semana3.les1.verse2" },
            { type: "verse", reference: "Filipenses 2:5-8", referenceKey: "programs.manual_estudiante.semana3.les1.reference3", textKey: "programs.manual_estudiante.semana3.les1.verse3" },
            { type: "text", textKey: "programs.manual_estudiante.semana3.les1.objectives" },
          ],
          questions: [
            { id: "sem3-q1", type: "reflection", promptKey: "programs.manual_estudiante.semana3.les1.q1" },
            { id: "sem3-q2", type: "reflection", promptKey: "programs.manual_estudiante.semana3.les1.q2" },
            { id: "sem3-q3", type: "reflection", promptKey: "programs.manual_estudiante.semana3.les1.q3" },
            { id: "sem3-q4", type: "application", promptKey: "programs.manual_estudiante.semana3.les1.q4" },
          ],
        },
      ],
    },
    {
      id: "semana-4",
      titleKey: "programs.manual_estudiante.semana4.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.manual_estudiante.semana4.les1.title",
          contentBlocks: [
            { type: "verse", reference: "Mateo 28:18-20", referenceKey: "programs.manual_estudiante.semana4.les1.reference1", textKey: "programs.manual_estudiante.semana4.les1.verse1" },
            { type: "verse", reference: "Hechos 1:8", referenceKey: "programs.manual_estudiante.semana4.les1.reference2", textKey: "programs.manual_estudiante.semana4.les1.verse2" },
            { type: "verse", reference: "Romanos 10:13-15", referenceKey: "programs.manual_estudiante.semana4.les1.reference3", textKey: "programs.manual_estudiante.semana4.les1.verse3" },
            { type: "text", textKey: "programs.manual_estudiante.semana4.les1.objectives" },
          ],
          questions: [
            { id: "sem4-q1", type: "reflection", promptKey: "programs.manual_estudiante.semana4.les1.q1" },
            { id: "sem4-q2", type: "reflection", promptKey: "programs.manual_estudiante.semana4.les1.q2" },
            { id: "sem4-q3", type: "reflection", promptKey: "programs.manual_estudiante.semana4.les1.q3" },
            { id: "sem4-q4", type: "application", promptKey: "programs.manual_estudiante.semana4.les1.q4" },
          ],
        },
      ],
    },
    {
      id: "semana-5",
      titleKey: "programs.manual_estudiante.semana5.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.manual_estudiante.semana5.les1.title",
          contentBlocks: [
            { type: "verse", reference: "Efesios 2:8-10", referenceKey: "programs.manual_estudiante.semana5.les1.reference1", textKey: "programs.manual_estudiante.semana5.les1.verse1" },
            { type: "verse", reference: "Jeremías 1:5", referenceKey: "programs.manual_estudiante.semana5.les1.reference2", textKey: "programs.manual_estudiante.semana5.les1.verse2" },
            { type: "verse", reference: "2 Timoteo 1:9", referenceKey: "programs.manual_estudiante.semana5.les1.reference3", textKey: "programs.manual_estudiante.semana5.les1.verse3" },
            { type: "text", textKey: "programs.manual_estudiante.semana5.les1.objectives" },
          ],
          questions: [
            { id: "sem5-q1", type: "reflection", promptKey: "programs.manual_estudiante.semana5.les1.q1" },
            { id: "sem5-q2", type: "reflection", promptKey: "programs.manual_estudiante.semana5.les1.q2" },
            { id: "sem5-q3", type: "reflection", promptKey: "programs.manual_estudiante.semana5.les1.q3" },
            { id: "sem5-q4", type: "application", promptKey: "programs.manual_estudiante.semana5.les1.q4" },
          ],
        },
      ],
    },
    {
      id: "semana-6",
      titleKey: "programs.manual_estudiante.semana6.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.manual_estudiante.semana6.les1.title",
          contentBlocks: [
            { type: "verse", reference: "Romanos 12:1-2", referenceKey: "programs.manual_estudiante.semana6.les1.reference1", textKey: "programs.manual_estudiante.semana6.les1.verse1" },
            { type: "verse", reference: "1 Timoteo 4:7-8", referenceKey: "programs.manual_estudiante.semana6.les1.reference2", textKey: "programs.manual_estudiante.semana6.les1.verse2" },
            { type: "verse", reference: "Juan 15:4-5", referenceKey: "programs.manual_estudiante.semana6.les1.reference3", textKey: "programs.manual_estudiante.semana6.les1.verse3" },
            { type: "text", textKey: "programs.manual_estudiante.semana6.les1.objectives" },
          ],
          questions: [
            { id: "sem6-q1", type: "reflection", promptKey: "programs.manual_estudiante.semana6.les1.q1" },
            { id: "sem6-q2", type: "reflection", promptKey: "programs.manual_estudiante.semana6.les1.q2" },
            { id: "sem6-q3", type: "reflection", promptKey: "programs.manual_estudiante.semana6.les1.q3" },
            { id: "sem6-q4", type: "application", promptKey: "programs.manual_estudiante.semana6.les1.q4" },
          ],
        },
      ],
    },
    {
      id: "semana-7",
      titleKey: "programs.manual_estudiante.semana7.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.manual_estudiante.semana7.les1.title",
          contentBlocks: [
            { type: "verse", reference: "Juan 13:34-35", referenceKey: "programs.manual_estudiante.semana7.les1.reference1", textKey: "programs.manual_estudiante.semana7.les1.verse1" },
            { type: "verse", reference: "Efesios 4:2-3", referenceKey: "programs.manual_estudiante.semana7.les1.reference2", textKey: "programs.manual_estudiante.semana7.les1.verse2" },
            { type: "verse", reference: "Proverbios 27:17", referenceKey: "programs.manual_estudiante.semana7.les1.reference3", textKey: "programs.manual_estudiante.semana7.les1.verse3" },
            { type: "text", textKey: "programs.manual_estudiante.semana7.les1.objectives" },
          ],
          questions: [
            { id: "sem7-q1", type: "reflection", promptKey: "programs.manual_estudiante.semana7.les1.q1" },
            { id: "sem7-q2", type: "reflection", promptKey: "programs.manual_estudiante.semana7.les1.q2" },
            { id: "sem7-q3", type: "reflection", promptKey: "programs.manual_estudiante.semana7.les1.q3" },
            { id: "sem7-q4", type: "application", promptKey: "programs.manual_estudiante.semana7.les1.q4" },
          ],
        },
      ],
    },
    {
      id: "semana-8",
      titleKey: "programs.manual_estudiante.semana8.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.manual_estudiante.semana8.les1.title",
          contentBlocks: [
            { type: "verse", reference: "Hechos 2:42-47", referenceKey: "programs.manual_estudiante.semana8.les1.reference1", textKey: "programs.manual_estudiante.semana8.les1.verse1" },
            { type: "verse", reference: "Efesios 4:11-13", referenceKey: "programs.manual_estudiante.semana8.les1.reference2", textKey: "programs.manual_estudiante.semana8.les1.verse2" },
            { type: "verse", reference: "1 Pedro 5:1-3", referenceKey: "programs.manual_estudiante.semana8.les1.reference3", textKey: "programs.manual_estudiante.semana8.les1.verse3" },
            { type: "text", textKey: "programs.manual_estudiante.semana8.les1.objectives" },
          ],
          questions: [
            { id: "sem8-q1", type: "reflection", promptKey: "programs.manual_estudiante.semana8.les1.q1" },
            { id: "sem8-q2", type: "reflection", promptKey: "programs.manual_estudiante.semana8.les1.q2" },
            { id: "sem8-q3", type: "reflection", promptKey: "programs.manual_estudiante.semana8.les1.q3" },
            { id: "sem8-q4", type: "application", promptKey: "programs.manual_estudiante.semana8.les1.q4" },
          ],
        },
      ],
    },
    {
      id: "semana-9",
      titleKey: "programs.manual_estudiante.semana9.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.manual_estudiante.semana9.les1.title",
          contentBlocks: [
            { type: "verse", reference: "Marcos 10:43-45", referenceKey: "programs.manual_estudiante.semana9.les1.reference1", textKey: "programs.manual_estudiante.semana9.les1.verse1" },
            { type: "verse", reference: "Juan 13:12-15", referenceKey: "programs.manual_estudiante.semana9.les1.reference2", textKey: "programs.manual_estudiante.semana9.les1.verse2" },
            { type: "verse", reference: "Filipenses 2:3-4", referenceKey: "programs.manual_estudiante.semana9.les1.reference3", textKey: "programs.manual_estudiante.semana9.les1.verse3" },
            { type: "text", textKey: "programs.manual_estudiante.semana9.les1.objectives" },
          ],
          questions: [
            { id: "sem9-q1", type: "reflection", promptKey: "programs.manual_estudiante.semana9.les1.q1" },
            { id: "sem9-q2", type: "reflection", promptKey: "programs.manual_estudiante.semana9.les1.q2" },
            { id: "sem9-q3", type: "reflection", promptKey: "programs.manual_estudiante.semana9.les1.q3" },
            { id: "sem9-q4", type: "application", promptKey: "programs.manual_estudiante.semana9.les1.q4" },
          ],
        },
      ],
    },
    {
      id: "semana-10",
      titleKey: "programs.manual_estudiante.semana10.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.manual_estudiante.semana10.les1.title",
          contentBlocks: [
            { type: "verse", reference: "Proverbios 11:3", referenceKey: "programs.manual_estudiante.semana10.les1.reference1", textKey: "programs.manual_estudiante.semana10.les1.verse1" },
            { type: "verse", reference: "Salmo 101:2-3", referenceKey: "programs.manual_estudiante.semana10.les1.reference2", textKey: "programs.manual_estudiante.semana10.les1.verse2" },
            { type: "verse", reference: "Tito 2:7-8", referenceKey: "programs.manual_estudiante.semana10.les1.reference3", textKey: "programs.manual_estudiante.semana10.les1.verse3" },
            { type: "text", textKey: "programs.manual_estudiante.semana10.les1.objectives" },
          ],
          questions: [
            { id: "sem10-q1", type: "reflection", promptKey: "programs.manual_estudiante.semana10.les1.q1" },
            { id: "sem10-q2", type: "reflection", promptKey: "programs.manual_estudiante.semana10.les1.q2" },
            { id: "sem10-q3", type: "reflection", promptKey: "programs.manual_estudiante.semana10.les1.q3" },
            { id: "sem10-q4", type: "application", promptKey: "programs.manual_estudiante.semana10.les1.q4" },
          ],
        },
      ],
    },
    {
      id: "semana-11",
      titleKey: "programs.manual_estudiante.semana11.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.manual_estudiante.semana11.les1.title",
          contentBlocks: [
            { type: "verse", reference: "Mateo 18:15-17", referenceKey: "programs.manual_estudiante.semana11.les1.reference1", textKey: "programs.manual_estudiante.semana11.les1.verse1" },
            { type: "verse", reference: "Romanos 12:17-18", referenceKey: "programs.manual_estudiante.semana11.les1.reference2", textKey: "programs.manual_estudiante.semana11.les1.verse2" },
            { type: "verse", reference: "Efesios 4:26-27", referenceKey: "programs.manual_estudiante.semana11.les1.reference3", textKey: "programs.manual_estudiante.semana11.les1.verse3" },
            { type: "text", textKey: "programs.manual_estudiante.semana11.les1.objectives" },
          ],
          questions: [
            { id: "sem11-q1", type: "reflection", promptKey: "programs.manual_estudiante.semana11.les1.q1" },
            { id: "sem11-q2", type: "reflection", promptKey: "programs.manual_estudiante.semana11.les1.q2" },
            { id: "sem11-q3", type: "reflection", promptKey: "programs.manual_estudiante.semana11.les1.q3" },
            { id: "sem11-q4", type: "application", promptKey: "programs.manual_estudiante.semana11.les1.q4" },
          ],
        },
      ],
    },
    {
      id: "semana-12",
      titleKey: "programs.manual_estudiante.semana12.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.manual_estudiante.semana12.les1.title",
          contentBlocks: [
            { type: "verse", reference: "Santiago 1:5", referenceKey: "programs.manual_estudiante.semana12.les1.reference1", textKey: "programs.manual_estudiante.semana12.les1.verse1" },
            { type: "verse", reference: "Proverbios 3:13-18", referenceKey: "programs.manual_estudiante.semana12.les1.reference2", textKey: "programs.manual_estudiante.semana12.les1.verse2" },
            { type: "verse", reference: "1 Reyes 3:9-12", referenceKey: "programs.manual_estudiante.semana12.les1.reference3", textKey: "programs.manual_estudiante.semana12.les1.verse3" },
            { type: "text", textKey: "programs.manual_estudiante.semana12.les1.objectives" },
          ],
          questions: [
            { id: "sem12-q1", type: "reflection", promptKey: "programs.manual_estudiante.semana12.les1.q1" },
            { id: "sem12-q2", type: "reflection", promptKey: "programs.manual_estudiante.semana12.les1.q2" },
            { id: "sem12-q3", type: "reflection", promptKey: "programs.manual_estudiante.semana12.les1.q3" },
            { id: "sem12-q4", type: "application", promptKey: "programs.manual_estudiante.semana12.les1.q4" },
          ],
        },
      ],
    },
    {
      id: "semana-13",
      titleKey: "programs.manual_estudiante.semana13.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.manual_estudiante.semana13.les1.title",
          contentBlocks: [
            { type: "verse", reference: "2 Timoteo 2:2", referenceKey: "programs.manual_estudiante.semana13.les1.reference1", textKey: "programs.manual_estudiante.semana13.les1.verse1" },
            { type: "verse", reference: "Mateo 28:19-20", referenceKey: "programs.manual_estudiante.semana13.les1.reference2", textKey: "programs.manual_estudiante.semana13.les1.verse2" },
            { type: "verse", reference: "Hechos 6:1-4", referenceKey: "programs.manual_estudiante.semana13.les1.reference3", textKey: "programs.manual_estudiante.semana13.les1.verse3" },
            { type: "text", textKey: "programs.manual_estudiante.semana13.les1.objectives" },
          ],
          questions: [
            { id: "sem13-q1", type: "reflection", promptKey: "programs.manual_estudiante.semana13.les1.q1" },
            { id: "sem13-q2", type: "reflection", promptKey: "programs.manual_estudiante.semana13.les1.q2" },
            { id: "sem13-q3", type: "reflection", promptKey: "programs.manual_estudiante.semana13.les1.q3" },
            { id: "sem13-q4", type: "application", promptKey: "programs.manual_estudiante.semana13.les1.q4" },
          ],
        },
      ],
    },
    {
      id: "semana-14",
      titleKey: "programs.manual_estudiante.semana14.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.manual_estudiante.semana14.les1.title",
          contentBlocks: [
            { type: "verse", reference: "2 Corintios 4:7-9", referenceKey: "programs.manual_estudiante.semana14.les1.reference1", textKey: "programs.manual_estudiante.semana14.les1.verse1" },
            { type: "verse", reference: "Filipenses 4:6-7", referenceKey: "programs.manual_estudiante.semana14.les1.reference2", textKey: "programs.manual_estudiante.semana14.les1.verse2" },
            { type: "verse", reference: "Salmo 46:1-2", referenceKey: "programs.manual_estudiante.semana14.les1.reference3", textKey: "programs.manual_estudiante.semana14.les1.verse3" },
            { type: "text", textKey: "programs.manual_estudiante.semana14.les1.objectives" },
          ],
          questions: [
            { id: "sem14-q1", type: "reflection", promptKey: "programs.manual_estudiante.semana14.les1.q1" },
            { id: "sem14-q2", type: "reflection", promptKey: "programs.manual_estudiante.semana14.les1.q2" },
            { id: "sem14-q3", type: "reflection", promptKey: "programs.manual_estudiante.semana14.les1.q3" },
            { id: "sem14-q4", type: "application", promptKey: "programs.manual_estudiante.semana14.les1.q4" },
          ],
        },
      ],
    },
    {
      id: "semana-15",
      titleKey: "programs.manual_estudiante.semana15.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.manual_estudiante.semana15.les1.title",
          contentBlocks: [
            { type: "verse", reference: "Lucas 16:10-11", referenceKey: "programs.manual_estudiante.semana15.les1.reference1", textKey: "programs.manual_estudiante.semana15.les1.verse1" },
            { type: "verse", reference: "2 Corintios 9:6-8", referenceKey: "programs.manual_estudiante.semana15.les1.reference2", textKey: "programs.manual_estudiante.semana15.les1.verse2" },
            { type: "verse", reference: "Mateo 6:24", referenceKey: "programs.manual_estudiante.semana15.les1.reference3", textKey: "programs.manual_estudiante.semana15.les1.verse3" },
            { type: "text", textKey: "programs.manual_estudiante.semana15.les1.objectives" },
          ],
          questions: [
            { id: "sem15-q1", type: "reflection", promptKey: "programs.manual_estudiante.semana15.les1.q1" },
            { id: "sem15-q2", type: "reflection", promptKey: "programs.manual_estudiante.semana15.les1.q2" },
            { id: "sem15-q3", type: "reflection", promptKey: "programs.manual_estudiante.semana15.les1.q3" },
            { id: "sem15-q4", type: "application", promptKey: "programs.manual_estudiante.semana15.les1.q4" },
          ],
        },
      ],
    },
    {
      id: "semana-16",
      titleKey: "programs.manual_estudiante.semana16.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.manual_estudiante.semana16.les1.title",
          contentBlocks: [
            { type: "verse", reference: "Hebreos 12:1-3", referenceKey: "programs.manual_estudiante.semana16.les1.reference1", textKey: "programs.manual_estudiante.semana16.les1.verse1" },
            { type: "verse", reference: "2 Timoteo 4:7-8", referenceKey: "programs.manual_estudiante.semana16.les1.reference2", textKey: "programs.manual_estudiante.semana16.les1.verse2" },
            { type: "verse", reference: "Gálatas 6:9", referenceKey: "programs.manual_estudiante.semana16.les1.reference3", textKey: "programs.manual_estudiante.semana16.les1.verse3" },
            { type: "text", textKey: "programs.manual_estudiante.semana16.les1.objectives" },
          ],
          questions: [
            { id: "sem16-q1", type: "reflection", promptKey: "programs.manual_estudiante.semana16.les1.q1" },
            { id: "sem16-q2", type: "reflection", promptKey: "programs.manual_estudiante.semana16.les1.q2" },
            { id: "sem16-q3", type: "reflection", promptKey: "programs.manual_estudiante.semana16.les1.q3" },
            { id: "sem16-q4", type: "application", promptKey: "programs.manual_estudiante.semana16.les1.q4" },
          ],
        },
      ],
    },
  ],
};
